import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Lightweight per-route SEO: sets document title and key meta tags.
 * The static head in public/index.html is the crawler floor; this keeps
 * titles unique per page for browsers and prerendered crawlers.
 */
const Seo = ({ title, description }) => {
  const location = useLocation();

  useEffect(() => {
    document.title = title;
    const setMeta = (selector, attr, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [kind, name] = attr;
        el.setAttribute(kind, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", value);
    };
    setMeta('meta[name="description"]', ["name", "description"], description);
    setMeta('meta[property="og:title"]', ["property", "og:title"], title);
    setMeta('meta[property="og:description"]', ["property", "og:description"], description);
    setMeta('meta[name="twitter:title"]', ["name", "twitter:title"], title);
    setMeta('meta[name="twitter:description"]', ["name", "twitter:description"], description);
    // Per-route canonical
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `https://bioregionalventures.com${location.pathname}`);
  }, [title, description, location.pathname]);

  return null;
};

export default Seo;
